module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container-content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('my-sidebar', {
    staticStyle: {
      "z-index": "20141224"
    }
  }), _vm._v(" "), (_vm.dialog) ? _c('my-dialog', {
    staticClass: "my-dialog"
  }) : _vm._e(), _vm._v(" "), (_vm.personindex) ? _c('my-personindex', {
    staticClass: "my-personindex"
  }) : _vm._e(), _vm._v(" "), (_vm.search) ? _c('my-search') : _vm._e(), _vm._v(" "), (_vm.mapwebview) ? _c('mapWebview') : _vm._e(), _vm._v(" "), (_vm.xiexinmapwebview) ? _c('xiexinMapwebview') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c757b14e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 527
// module chunks = 1